import { IAjaxConfig } from '../libraries';
export class EnumApiUsersvr {
  /**
   * @dec 获取省份
   * @method get
   */
  readonly usersvr_get_provinces: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/provinces',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 获取城市
   * @method get
   */
  readonly usersvr_get_citys: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/cities/{provideCode}',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 获取区县、街道
   * @method get
   */
  readonly usersvr_get_district: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/district/{CityCode}',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 根据userId查询sales的bu
   */
  readonly bffsvr_get_sales_by_userid: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/bu/userId/get',
    method: 'get',
  };
}
